import type { CatalogItem } from '@/entities/catalog-item';
import type { SymbolKey } from '@/entities/symbol';

export const FORWARD_CURVE_PERIOD_WILDCARD = '*';

const buildCatalogKey = (code: string, periodType: string, timeRef: string) =>
  `${code}|${periodType}|${timeRef}`;

const indexCatalog = (catalog: CatalogItem[]) => {
  const idx = new Map<string, CatalogItem>();
  for (const item of catalog) {
    idx.set(buildCatalogKey(item.Code, item.PeriodType, item.TimeRef), item);
  }
  return idx;
};

export const hasForwardCurveWildcard = (symbols: SymbolKey[]) =>
  symbols.some(s => s.Period === FORWARD_CURVE_PERIOD_WILDCARD);

export const expandForwardCurveWildcards = (
  symbols: SymbolKey[],
  catalog: CatalogItem[] | undefined
): SymbolKey[] => {
  if (!hasForwardCurveWildcard(symbols)) return symbols;
  if (!catalog || catalog.length === 0) return symbols;

  const idx = indexCatalog(catalog);
  const expanded: SymbolKey[] = [];

  for (const symbol of symbols) {
    if (symbol.Period !== FORWARD_CURVE_PERIOD_WILDCARD) {
      expanded.push(symbol);
      continue;
    }
    const entry = idx.get(buildCatalogKey(symbol.Code, symbol.PeriodType, symbol.TimeRef));
    const min = Number(entry?.PeriodMin);
    const max = Number(entry?.PeriodMax);
    if (!entry || !Number.isFinite(min) || !Number.isFinite(max) || min > max) {
      expanded.push(symbol);
      continue;
    }
    for (let p = min; p <= max; p++) {
      expanded.push({
        Code: symbol.Code,
        PeriodType: symbol.PeriodType,
        TimeRef: symbol.TimeRef,
        Period: String(p),
        ...(symbol.transactionDate !== undefined && { transactionDate: symbol.transactionDate })
      });
    }
  }

  return expanded;
};
